module.exports = __webpack_public_path__ + "media/localization/chinese-65e1594a.png";